import { parseJson, touch } from 'helpers/transforms'
import { last } from 'libraries/lodash'
import dayjs from 'dayjs'
import { DATE_FORMAT, TIME_FORMAT } from 'constants/locale'
import debug from 'front-end-core/core/debug'

export const toComments = function (data) {
  const parsedData = parseJson(data)
  const { results } = parsedData

  const references = {}
  const entries = {}

  const toDate = timestamp =>
    dayjs(timestamp).format(`${DATE_FORMAT} ${TIME_FORMAT}`)

  results.forEach(entry => {
    const content = parseJson(entry.content.content)
    const id = last(entry.content.uri.split(':'))
    const active = !!content.active

    const splitTarget = entry.content.target.split(':')
    const target = last(splitTarget)
    const aol = splitTarget[splitTarget.length - 2]

    if (!entry.party) {
      return (
        debug.warn(
          `Comment ${entry.content.uri} is missing party information`
        ) || null
      )
    }

    entries[id] = {
      active,
      aol,
      category: content.category,
      lastModified: toDate(entry.content.upsertTimestamp),
      dateCreated: toDate(
        entry.content.creationTimestamp || entry.content.upsertTimestamp
      ),
      date: toDate(entry.content.upsertTimestamp),
      encrypted: content.body,
      id,
      partyName: `${entry.party.firstName} ${entry.party.lastName}`,
      partyRole: '',
      partyType: entry.party.type,
      partyUrn: entry.party.uri,
      privacy: entry.content.isPrivate ? 'private' : 'public',
      reference: content.reference,
      target,
      uri: entry.uri
    }

    touch(references, [content.reference], []).push(id)
  })

  return { entries, references }
}
